import { render } from "./CounterModal.vue?vue&type=template&id=1a21aa8e&ts=true"
import script from "./CounterModal.vue?vue&type=script&lang=ts"
export * from "./CounterModal.vue?vue&type=script&lang=ts"

import "./CounterModal.vue?vue&type=style&index=0&id=1a21aa8e&lang=scss"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__